module.exports = __webpack_public_path__ + "docs/AcreTrader-Form-CRS.pdf";